import { CarpoolVehicle } from '../types';

/**
 * Prüft ob ein Fahrzeug einen aktiven Vertrag hat
 */
export const isVehicleActive = (vehicle: CarpoolVehicle): boolean => {
  // Verwende contract_end_date oder fallback auf end_of_contract
  const endDate = vehicle.contract_end_date || vehicle.end_of_contract;
  if (!endDate) {
    return true; // Kein Enddatum = aktiver Vertrag
  }
  
  const endDateObj = new Date(endDate);
  const today = new Date();
  
  // Setze Uhrzeit auf Mitternacht für korrekten Vergleich
  today.setHours(0, 0, 0, 0);
  endDateObj.setHours(0, 0, 0, 0);
  
  return endDateObj >= today;
};

/**
 * Berechnet die verbleibenden Tage bis zum Vertragsende
 */
export const getDaysUntilContractEnd = (vehicle: CarpoolVehicle): number | null => {
  // Verwende contract_end_date oder fallback auf end_of_contract
  const endDate = vehicle.contract_end_date || vehicle.end_of_contract;
  if (!endDate) {
    return null;
  }
  
  const endDateObj = new Date(endDate);
  const today = new Date();
  
  // Setze Uhrzeit auf Mitternacht für korrekten Vergleich
  today.setHours(0, 0, 0, 0);
  endDateObj.setHours(0, 0, 0, 0);
  
  const diffTime = endDateObj.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays;
};

/**
 * Gibt eine Warnung zurück wenn der Vertrag bald endet
 */
export const getContractEndWarning = (vehicle: CarpoolVehicle): string | null => {
  const daysLeft = getDaysUntilContractEnd(vehicle);
  
  if (daysLeft === null) {
    return null;
  }
  
  if (daysLeft < 0) {
    return 'Vertrag beendet';
  } else if (daysLeft <= 30) {
    return `Vertrag läuft in ${daysLeft} Tagen ab`;
  } else if (daysLeft <= 90) {
    return `Vertrag läuft in ${daysLeft} Tagen ab`;
  }
  
  return null;
};

/**
 * Filtert Fahrzeuge nach aktiven/beendeten Verträgen
 */
export const filterActiveVehicles = (vehicles: CarpoolVehicle[]): CarpoolVehicle[] => {
  return vehicles.filter(isVehicleActive);
};

export const filterEndedVehicles = (vehicles: CarpoolVehicle[]): CarpoolVehicle[] => {
  return vehicles.filter(vehicle => !isVehicleActive(vehicle));
}; 